import { at, lookup } from "./util";
export const SUITS = ["spades", "hearts", "diamonds", "clubs"];
/** 2-10 pips; 11 jack, 12 queen, 13 king, 14 ace */
export const RANKS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
export const JACK = 11;
export const QUEEN = 12;
export const KING = 13;
export const ACE = 14;
export const PLAYER_COUNT = 4;
export const HAND_SIZE = 13;
export function cardKey(card) {
    return `${card.suit}:${card.rank}`;
}
export function isSuit(value) {
    return typeof value === "string" && SUITS.includes(value);
}
export function isRank(value) {
    return typeof value === "number" && RANKS.includes(value);
}
export function isCard(value) {
    if (typeof value !== "object" || value === null)
        return false;
    const card = value;
    return isSuit(card.suit) && isRank(card.rank);
}
export function createDeck() {
    const deck = [];
    for (const suit of SUITS) {
        for (const rank of RANKS)
            deck.push({ suit, rank });
    }
    return deck;
}
/** Fisher-Yates; the input is left untouched and randomness is injected. */
export function shuffle(items, rng) {
    const result = [...items];
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        const a = at(result, i);
        result[i] = at(result, j);
        result[j] = a;
    }
    return result;
}
/** Every hand but the viewer's; a spectator (`null`) holds none, so all of them (ADR 0050). */
export function otherHands(hands, seat) {
    return hands.flatMap((hand, holder) => (holder === seat ? [] : hand));
}
/** Deals 52 cards to 4 players, 13 each. */
export function dealHands(deck) {
    const expected = PLAYER_COUNT * HAND_SIZE;
    if (deck.length !== expected) {
        throw new RangeError(`deck must hold ${expected} cards, got ${deck.length}`);
    }
    const hands = [[], [], [], []];
    for (const [i, card] of deck.entries())
        at(hands, i % PLAYER_COUNT).push(card);
    return hands;
}
/**
 * Display order alternates colours so hearts and diamonds never sit side by
 * side; within a suit, high to low.
 */
export const DISPLAY_SUIT_ORDER = ["spades", "hearts", "clubs", "diamonds"];
export function sortForDisplay(hand) {
    return [...hand].sort((a, b) => {
        const bySuit = DISPLAY_SUIT_ORDER.indexOf(a.suit) - DISPLAY_SUIT_ORDER.indexOf(b.suit);
        return bySuit !== 0 ? bySuit : b.rank - a.rank;
    });
}
/** Cards grouped by suit, each group high to low. Every suit has an entry. */
export function groupBySuit(hand) {
    const groups = new Map(SUITS.map((suit) => [suit, []]));
    for (const card of hand)
        lookup(groups, card.suit).push(card);
    for (const cards of groups.values())
        cards.sort((a, b) => b.rank - a.rank);
    return groups;
}
//# sourceMappingURL=cards.js.map